// extracted by mini-css-extract-plugin
export var bannerWp = "blogs-module--banner-wp--3NLI7";
export var blogsVideo = "blogs-module--blogs-video--2uA3C";
export var blogItem = "blogs-module--blog-item--nVtGn";
export var blogsItemImg = "blogs-module--blogs-item-img--1kPm2";
export var blogItemColor = "blogs-module--blog-item-color--MSGGA";